import { Component, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { HttpService } from '../../services/http-service/http.service';
import { environment } from '../../../environments/environment';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-call-to-action',
  imports: [FormsModule, CommonModule],
  templateUrl: './call-to-action.component.html',
  styleUrl: './call-to-action.component.scss'
})
export class CallToActionComponent implements AfterViewInit {
  @ViewChild('sectionRef') sectionRef!: ElementRef<HTMLDivElement>;
  email: string = "";

  constructor(private http: HttpService){}

  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    );

    const elements = this.sectionRef.nativeElement.querySelectorAll('.appear-on-scroll');
    elements.forEach(el => observer.observe(el));
  }

  // ✅ Add this method to fix the error
  onSubscribe(): void {
    console.log('Subscription form submitted');
    if(!this.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)){
      return;
    }
    const mailData = {
      email: this.email
    };
    this.http.post(`${environment.API_ENDPOINT}/api/home/mail`,mailData).subscribe(res => {

    })
  }
}
